export default "__VITE_ASSET__216db141__"